export enum EmployeeDetailsDrawerView {
  Details,
  Edit,
}
